// Trello 437: the backend drives the OTP cell count with an integer
// `otp_length` (4 or 6, default 4) on the responses that start/continue the
// OTP flow — register, resend-OTP (activate-email), activation, and
// app-config. Persist the latest value seen so a returning visit to an OTP
// page renders the same count; anything absent/malformed falls back to 4.
export const DEFAULT_OTP_LENGTH = 4;
export const OTP_LENGTH_STORAGE_KEY = "otp_length";

const VALID_OTP_LENGTHS = [4, 6];

// `otp_length` may sit at the response root or inside the legacy
// { meta, data } envelope (and, for register, inside `authorization`).
export const extractOtpLength = (payload) => {
  const candidates = [
    payload,
    payload && payload.data,
    payload && payload.authorization,
  ];
  let found = null;
  candidates.forEach((candidate) => {
    if (found !== null || !candidate) return;
    const raw = candidate.otp_length;
    const parsed = parseInt(raw, 10);
    // String(raw) must equal String(parsed) so floats ("6.5") and padded
    // strings ("06") don't smuggle a truncated value through.
    if (
      VALID_OTP_LENGTHS.indexOf(parsed) !== -1
      && String(raw).trim() === String(parsed)
    ) {
      found = parsed;
    }
  });
  return found;
};

// Persist the flag when the response carries it; returns the parsed length
// (or null) so callers can re-render without re-reading storage.
export const persistOtpLength = (payload) => {
  const otpLength = extractOtpLength(payload);
  if (otpLength === null || typeof window === "undefined") {
    return otpLength;
  }
  try {
    localStorage.setItem(OTP_LENGTH_STORAGE_KEY, String(otpLength));
  } catch (e) { /* localStorage full or disabled */ }
  return otpLength;
};

export const getOtpLength = () => {
  if (typeof window === "undefined") return DEFAULT_OTP_LENGTH;
  try {
    const parsed = parseInt(localStorage.getItem(OTP_LENGTH_STORAGE_KEY), 10);
    return VALID_OTP_LENGTHS.indexOf(parsed) !== -1 ? parsed : DEFAULT_OTP_LENGTH;
  } catch (e) {
    return DEFAULT_OTP_LENGTH;
  }
};
